import moment from 'moment-timezone';

import { ISchedule } from '../schedule';
import { ISession, SingleCommunication } from '../session';

export enum Variant {
  B = 'B'
}

export interface IEpxCOPDSchedule extends ISchedule {
  variant?: Variant;
  shouldAskSymptoms?: boolean;
  shouldAskNebulizer?: boolean;
  shouldAskFever?: boolean;
}

export interface IEpxCOPD
  extends ISession<IEpxCOPDSchedule>, SingleCommunication {
  variant?: Variant;
  // Regular
  sputum?: number;
  coughing?: number;
  breathing?: number;
  shouldAskSymptoms?: boolean;
  shouldAskNebulizer: boolean;
  hasUsedNebulizer?: boolean;
  shouldAskFever: boolean;
  hasFever?: boolean;
  // Variant B
  wantsToSpeak?: boolean;
}

export function ProcessSchedule<
  T extends {
    times: string[];
  }
>(data: T, schedule: IEpxCOPDSchedule): T {
  const start = moment.tz(schedule.start, schedule.tz);
  const times = [start.format('HH:mm')];
  data.times = times;
  return data;
}
